/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BcProductListResponse } from '../../models/bc-product-list-response';

export interface GetAllProducts$Params {
}

export function getAllProducts(http: HttpClient, rootUrl: string, params?: GetAllProducts$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<BcProductListResponse>>> {
  const rb = new RequestBuilder(rootUrl, getAllProducts.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<BcProductListResponse>>;
    })
  );
}

getAllProducts.PATH = '/business-central/products/all';
